import { createFileRoute } from '@tanstack/react-router';
import { NotificationsTemplatesPage } from './-components/NotificationsTemplatesPage';

export const Route = createFileRoute('/_auth/settings/notifications/templates')({
  component: NotificationsTemplatesPage,
});
